import config from "@/config";
import useDialog from "./useDialog";
import { ModalTransition, TrayDeleteDialog } from "@/Components";

const { toggleDialog, forceClose } = useDialog();

export default function useTrayDeleteDialog() {
    const toggleTrayDeleteDialog = (event, data) => {
        toggleDialog(
            TrayDeleteDialog,
            ModalTransition,
            data,
            event,
            config.dialogs.drawers.pinsDialog.zindex,
            true
        );
    };

    return {
        toggleTrayDeleteDialog,
        forceClose,
    };
}
